import { type FC, type ReactNode, useEffect, useRef } from 'react';
import { initiateUserback } from './utils';
import './style.css';
import { useAsync } from 'react-use';
import { useMe } from '@/account/profile/api';
import { useHasAccessToken } from '@/auth/api';
import { WORKSPACE } from '@/base/constants';
import { ClientOnly } from '@/shared/ClientOnly';
import { flattenObject } from '@/shared/js';
import { useIsDesktop } from '@/shared/react';
import { useRuntimeEnv } from '@/shared/runtimeEnv';

export * from './utils';

const RawUserbackProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const me = useMe();
  const hasAccessToken = useHasAccessToken();
  const isDesktop = useIsDesktop();
  const runtimeEnv = useRuntimeEnv();
  const lastUser = useRef<string>('');

  const { value: userback } = useAsync(initiateUserback);

  useEffect(() => {
    userback;
    const tm = setTimeout(() => {
      const hasBottomNav =
        (WORKSPACE === 'app' || WORKSPACE === 'admin') && !isDesktop;
      const feedbackEl =
        document.querySelector<HTMLDivElement>('.userback-button');
      if (feedbackEl) {
        feedbackEl.style.cssText = hasBottomNav
          ? '--widget-launcher-offset-y: 4.75rem'
          : '';
      }
    }, 500);
    return () => clearTimeout(tm);
  }, [isDesktop, userback]);

  useEffect(() => {
    if (!userback) return;
    if (me.data?.external_id) {
      userback.identify(me.data.external_id, {
        name: me.data.full_name,
        email: me.data.email,
      });
      lastUser.current = me.data.external_id;
    } else if (lastUser.current && !hasAccessToken) {
      // The userback.refresh cause userback destroy. this hacky way is just fix the problem
      const x = setTimeout(() => {
        window.location.reload();
      }, 50);
      lastUser.current = '';
      return () => clearTimeout(x);
    }
  }, [
    me.data?.external_id,
    me.data?.full_name,
    me.data?.email,
    userback,
    hasAccessToken,
  ]);

  useEffect(() => {
    if (!userback) return;
    userback.setData(flattenObject(runtimeEnv));
  }, [userback, runtimeEnv]);

  return <>{children}</>;
};

export const UserbackProvider: typeof RawUserbackProvider = ({ children }) => (
  <ClientOnly fallback={children}>
    <RawUserbackProvider>{children}</RawUserbackProvider>
  </ClientOnly>
);
